export default {
    created() {
        // if (this.form instanceof Object) {
        //     if (this.$route.query) Object.assign(this.form, this.$route.query);
        //     this.form.page = +this.form.page;
        //     for (const key in this.form) {
        //         if (key.includes('_id') && !!this.form[key] && typeof this.form[key] === 'string') {
        //             this.form[key] = +this.form[key];
        //         }
        //     }
        // }
        // if (this.$route.query.activeName) this.activeName = this.$route.query.activeName;
    },
    computed: {
        activeName: {
            get: function () {
                if (this.$route.query.activeName) return this.$route.query.activeName;
                return this.editableTabs.find(el => el.isShow).name;
            },
            set: function (newValue) {
                this.$router.replace({query: {activeName: newValue}})
            }
        },
    },
    watch: {
        // loading(val) {
        //     if (this.form instanceof Object) {
        //         if (!val) this.$router.replace({query: this.form});
        //     }
        // },
        // 'activeName'(val) {
        //     if (val) this.$router.replace({query: {activeName: this.activeName}});
        // },
        '$route.query.activeName'(val) {
            this.activeName = val;
        },
    },
};
